export default __webpack_public_path__ + "static/media/Minicard_5h.c4d5edda.svg";